import { InputBase, styled } from '@mui/material';

const StyledBaseInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(2)
  },
  '& .MuiInputBase-input': {
    borderRadius: '8px',
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #202020',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    alignItems: 'center',
    display: 'flex',
    '&:focus': {
      borderRadius: '8px'
    }
  }
}));

export default StyledBaseInput;
